import { Col, Row } from "antd";
import dayjs from "dayjs";
import { get } from "lodash";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import format from "string-template";
import {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  PROJECT_TYPES,
  SALE_MODES,
  SUBSCRIPTION_FORM_KEYS,
} from "utils/constants";
import { MEMBERSHIP_NATURE_OPTIONS, isMiltisObseques } from "../../../obseques";

const Contract = ({
  initialValues,
  setPercent,
  isFieldRequired,
  bindField,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  const eSignDisabled =
    get(initialValues, "project.contract.saleMode") === SALE_MODES.DISTANT &&
    get(initialValues, "project.projectType") === PROJECT_TYPES.COLD_LEAD &&
    get(initialValues, "createdDate") &&
    moment().diff(get(initialValues, "createdDate"), "hours") <= 24;

  const issuanceDatePath = "project.contract.issuanceDate";
  const issuanceDateField = bindField(issuanceDatePath, {
    label: SUBSCRIPTION.FORM.START_DATE.LABEL,
    required: isFieldRequired(issuanceDatePath),
    disabled: true,
    onBlur: () => setPercent(initialValues),
  });

  const createdDatePath = "createdDate";
  const createdDateField = bindField(createdDatePath, {
    label: SUBSCRIPTION.FORM.QUOTE_RECEIVED_DATE.LABEL,
    required: isFieldRequired(createdDatePath),
    disabled: true,
    onBlur: () => setPercent(initialValues),
  });
  const isObseques = isMiltisObseques(initialValues);
  const membershipNaturePath = "project.fields.membershipNature";
  const membershipNatureField = bindField(membershipNaturePath, {
    label: SUBSCRIPTION.FORM.MEMBERSHIP_NATURE.LABEL,
    required: isFieldRequired(membershipNaturePath),
    onChange: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.CONTRACT}-section`}
    >
      <Form
        type="vertical"
        title={SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.CONTRACT.TITLE}
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <FormField
              path={issuanceDateField.path}
              label={issuanceDateField.label}
              required={issuanceDateField.required}
              disabled={issuanceDateField.disabled}
            >
              {(field) => (
                <Input
                  placeholder={SUBSCRIPTION.FORM.START_DATE.PLACEHOLDER}
                  type="date"
                  variant="simple"
                  label={issuanceDateField.label}
                  defaultValue={
                    get(initialValues, issuanceDatePath) &&
                    dayjs(get(initialValues, issuanceDatePath))
                  }
                  {...field}
                  onChange={issuanceDateField.onChange}
                  onBlur={issuanceDateField.onBlur}
                  format={DATE_FORMAT}
                />
              )}
            </FormField>
          </Col>
          {isObseques && (
            <Col lg={24} xs={24}>
              <FormField
                path={membershipNatureField.path}
                label={membershipNatureField.label}
                required={membershipNatureField.required}
                disabled={membershipNatureField.disabled}
              >
                {(field) => (
                  <Input
                    type="radio"
                    variant="group"
                    values={MEMBERSHIP_NATURE_OPTIONS}
                    label={membershipNatureField.label}
                    value={get(initialValues, membershipNaturePath)}
                    {...field}
                    onChange={membershipNatureField.onChange}
                    onBlur={membershipNatureField.onBlur}
                  />
                )}
              </FormField>
            </Col>
          )}
          <Col lg={24} xs={24}>
            <FormField
              path={createdDateField.path}
              label={createdDateField.label}
              required={createdDateField.required}
              disabled={createdDateField.disabled}
            >
              {(field) => (
                <Input
                  placeholder={
                    SUBSCRIPTION.FORM.QUOTE_RECEIVED_DATE.PLACEHOLDER
                  }
                  type="date"
                  variant="simple"
                  label={createdDateField.label}
                  defaultValue={
                    get(initialValues, createdDatePath) &&
                    dayjs(get(initialValues, createdDatePath))
                  }
                  {...field}
                  onChange={createdDateField.onChange}
                  onBlur={createdDateField.onBlur}
                  format={DATE_TIME_FORMAT}
                />
              )}
            </FormField>
            {eSignDisabled && get(initialValues, "createdDate") && (
              <span className="warning-message">
                {format(SUBSCRIPTION.ADDITIONAL_INFORMATION.E_SIGN, {
                  time: moment(get(initialValues, "createdDate"))
                    .add(24, "hours")
                    .format(DATE_TIME_FORMAT),
                })}
              </span>
            )}
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Contract;
